import React, { useMemo } from 'react';
import { i18n } from '@lt/localization';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

import type { IFilter } from '../types';

const FILTER_NAME = 'category';
const FILTER_LABEL = i18n.t('filters.category.title');

const REST_TYPES = {
  FAMILY: i18n.t('filters.category.family'),
  COUPLES: i18n.t('filters.category.couples'),
  ACTIVE: i18n.t('filters.category.active'),
};

const makeItems = (data) =>
  data.map((item) => ({ ...item, name: REST_TYPES[item.id] }));

const FilterCategory = ({
  data,
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => {
  const items = useMemo(() => makeItems(data), [data]);
  return (
    <MultichoiceFilterGroup
      className={className}
      data={items}
      isMobile={isMobile}
      Filter={FilterCategory}
      {...props}
    />
  );
};

export default Object.assign(FilterCategory, {
  filterName: FILTER_NAME,
  filterLabel: FILTER_LABEL,
  valuesLabel: (data) =>
    data
      .filter((item) => item.selected)
      .map((item) => REST_TYPES[item.id])
      .reduce((prev, curr) => [prev, ', ', curr]),
});
